import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var sessionToken = require("../constants/credentials");
var Parse = require("parse");

/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.Jober
 * @static
 * @hideconstructor
 */

/**
* Create a new client with no verification needed
* @method createClient
* @name Jobin.Jober.createJober
* @param {string} name
* @param {string} phone
* @param {string} [email]
* @returns {ParseObject} New user.
*/
export function createJober(_x, _x2, _x3) {
  return _createJober.apply(this, arguments);
}
/**
 * Create a new client with no verification needed
 * @method createClient
 * @name Jobin.Jober.updateJoberLocationAndTasks
 * @param {Parse.User} jober Jober to update
 * @param {number} latitude latitude of jober
 * @param {number} longitude logitude of jober
 * @param {string[]} verticalIds Verticals to subscribe
 * @param {boolean} [isDefaultJober] if this jober can make Fixed jobs
 * @returns {undefined} Confirmation of success
 */
function _createJober() {
  _createJober = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(name, phone, email) {
    var userId;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return Parse.Cloud.run("createJober", {
            phone: phone,
            joberName: name,
            email: email
          });
        case 3:
          userId = _context.sent;
          _context.next = 6;
          return new Parse.Query(Parse.User).get(userId);
        case 6:
          _context.t0 = _context.sent;
          return _context.abrupt("return", {
            status: "ok",
            result: _context.t0
          });
        case 10:
          _context.prev = 10;
          _context.t1 = _context["catch"](0);
          console.error(_context.t1);
          return _context.abrupt("return", {
            status: "error",
            result: "Error al registrar el nuevo usuario."
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  }));
  return _createJober.apply(this, arguments);
}
export function updateJoberLocationAndTasks(_x4, _x5, _x6, _x7, _x8) {
  return _updateJoberLocationAndTasks.apply(this, arguments);
}
/**
 * Get all the job info
 * @method getJoberById
 * @name Jobin.Jober.getJoberById
 * @param {string} joberId
 * @returns {ParseObject} Jober.
 */
function _updateJoberLocationAndTasks() {
  _updateJoberLocationAndTasks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(jober, latitude, longitude, verticalIds, isDefaultJober) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return Parse.Cloud.run("updateJoberLocationAndTasks", {
            joberId: jober.id,
            latitude: latitude,
            longitude: longitude,
            verticalIds: verticalIds,
            isDefaultJober: isDefaultJober
          });
        case 3:
          return _context2.abrupt("return", {
            status: "ok"
          });
        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);
          return _context2.abrupt("return", {
            status: "error",
            result: "Error al actualizar usuario."
          });
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return _updateJoberLocationAndTasks.apply(this, arguments);
}
export function getJoberById(_x9) {
  return _getJoberById.apply(this, arguments);
}
/**
 * Get all the job info
 * @method searchJobers
 * @name Jobin.Jober.searchJobers
 * @param {Array} levelArray
 * @param {int} distance
 * @param {Object} location
 * @param {int} minPoints
 * @param {int} minLeads
 * @param {Date} lastConnectionStartDate
 * @param {Date} lastConnectionEndDate
 * @param {Array} guilds
 * @param {string} phone
 * @param {int} limit
 * @returns {Array} Jober array.
 */
function _getJoberById() {
  _getJoberById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(joberId) {
    var User, query, jober;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          User = Parse.Object.extend("User");
          query = new Parse.Query(User);
          query.equalTo("objectId", joberId);
          query.equalTo("Jober", true);
          _context3.prev = 4;
          _context3.next = 7;
          return query.first();
        case 7:
          jober = _context3.sent;
          return _context3.abrupt("return", {
            status: "ok",
            result: jober
          });
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](4);
          console.error(_context3.t0);
          return _context3.abrupt("return", {
            status: "error",
            result: "Hubo un error al tratar de obtener la información del trabajo."
          });
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[4, 11]]);
  }));
  return _getJoberById.apply(this, arguments);
}
export function search(_x10, _x11, _x12, _x13, _x14, _x15, _x16, _x17, _x18, _x19) {
  return _search.apply(this, arguments);
}
/**
 * Get Jober info object (number of reviews, stars, displacement price, number of employees...)
 * @method getInfo
 * @name Jobin.Jober.getInfo
 * @param {ParseObject} jober (optional)
 * @returns {ParseObject} Jober info.
 */
function _search() {
  _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(levelArray, distance, location, minPoints, minLeads, lastConnectionStartDate, lastConnectionEndDate, guilds, phone, limit) {
    var query, queryGuilds, result, tempArray;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          query = new Parse.Query(Parse.User);
          query.equalTo("Jober", true);
          if (levelArray) query.containedIn("Level", levelArray);
          if (distance && location) query.withinKilometers("Location", location, distance, true);
          if (minPoints) query.greaterThanOrEqualTo("Points", minPoints);
          if (minLeads) query.greaterThanOrEqualTo("nJobs", minLeads);
          if (lastConnectionEndDate) query.lessThanOrEqualTo("Updated", lastConnectionEndDate);
          if (lastConnectionStartDate) query.greaterThanOrEqualTo("Updated", lastConnectionStartDate);
          if (phone) query.contains("Phone", phone);
          if (limit) query.limit(limit);
          query.descending("Updated");
          if (!(guilds && guilds.length > 0)) {
            _context4.next = 30;
            break;
          }
          queryGuilds = new Parse.Query("Task");
          queryGuilds.containedIn("Type", guilds);
          queryGuilds.matchesQuery("User", query);
          queryGuilds.include("User");
          _context4.prev = 16;
          _context4.next = 19;
          return queryGuilds.find();
        case 19:
          result = _context4.sent;
          tempArray = result.map(function (item) {
            return item.get("User");
          });
          return _context4.abrupt("return", {
            status: "ok",
            result: tempArray
          });
        case 24:
          _context4.prev = 24;
          _context4.t0 = _context4["catch"](16);
          console.error(_context4.t0);
          return _context4.abrupt("return", {
            status: "error",
            result: "Hubo un error al tratar de obtener la información del trabajo."
          });
        case 28:
          _context4.next = 41;
          break;
        case 30:
          _context4.prev = 30;
          _context4.next = 33;
          return query.find();
        case 33:
          _context4.t1 = _context4.sent;
          return _context4.abrupt("return", {
            status: "ok",
            result: _context4.t1
          });
        case 37:
          _context4.prev = 37;
          _context4.t2 = _context4["catch"](30);
          console.error(_context4.t2);
          return _context4.abrupt("return", {
            status: "error",
            result: "Hubo un error al tratar de obtener la información del trabajo."
          });
        case 41:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[16, 24], [30, 37]]);
  }));
  return _search.apply(this, arguments);
}
export function getInfo(_x20) {
  return _getInfo.apply(this, arguments);
}
/**
 * Get Jober tasks
 * @method getTasks
 * @name Jobin.Jober.getTasks
 * @param {ParseObject} jober (optional)
 * @returns {Array} Tasks objects.
 */
function _getInfo() {
  _getInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(jober) {
    var currentUser, isJober, Jober, query;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context5.sent;
          if (currentUser) {
            isJober = currentUser.get("Jober");
            if (isJober) {
              jober = currentUser;
            }
          }
          Jober = Parse.Object.extend("Jober");
          query = new Parse.Query(Jober);
          query.equalTo("Jober", jober);
          _context5.prev = 7;
          _context5.next = 10;
          return query.first();
        case 10:
          _context5.t0 = _context5.sent;
          return _context5.abrupt("return", {
            status: "ok",
            result: _context5.t0
          });
        case 14:
          _context5.prev = 14;
          _context5.t1 = _context5["catch"](7);
          console.error(_context5.t1);
          return _context5.abrupt("return", {
            status: "error",
            result: "No se pudo obtener la información del Jober debido a un error. Inténtalo de nuevo más tarde."
          });
        case 18:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[7, 14]]);
  }));
  return _getInfo.apply(this, arguments);
}
export function getTasks(_x21) {
  return _getTasks.apply(this, arguments);
}
/**
 * Get the Jober last review.
 * @method getLastReview
 * @name Jobin.Jober.getLastReview
 * @param {ParseObject} jober (optional)
 * @returns {ParseObject} Jober last review.
 */
function _getTasks() {
  _getTasks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(jober) {
    var currentUser, isJober, query;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context6.sent;
          if (currentUser) {
            isJober = currentUser.get("Jober");
            if (isJober) {
              jober = currentUser;
            }
          }
          query = new Parse.Query("Task");
          query.equalTo("User", jober);
          _context6.prev = 6;
          _context6.next = 9;
          return query.find();
        case 9:
          _context6.t0 = _context6.sent;
          return _context6.abrupt("return", {
            status: "ok",
            result: _context6.t0
          });
        case 13:
          _context6.prev = 13;
          _context6.t1 = _context6["catch"](6);
          console.error(_context6.t1);
          return _context6.abrupt("return", {
            status: "error",
            result: "No se pudo obtener las verticales a las que está inscrito este Jober."
          });
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[6, 13]]);
  }));
  return _getTasks.apply(this, arguments);
}
export function getLastReview(_x22) {
  return _getLastReview.apply(this, arguments);
}
/**
 * Get all Jober reviews.
 * @method getAllReviews
 * @name Jobin.Jober.getAllReviews
 * @param {ParseObject} jober (optional)
 * @returns {Array} All Jober reviews.
 */
function _getLastReview() {
  _getLastReview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(jober) {
    var currentUser, isJober, Review, query;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context7.sent;
          if (currentUser) {
            isJober = currentUser.get("Jober");
            if (isJober) {
              jober = currentUser;
            }
          }
          Review = Parse.Object.extend("Review");
          query = new Parse.Query(Review);
          query.equalTo("Jober", jober);
          query.include(["Job.Title", "User.Name"]);
          query.descending("createdAt");
          _context7.prev = 9;
          _context7.next = 12;
          return query.first();
        case 12:
          _context7.t0 = _context7.sent;
          return _context7.abrupt("return", {
            status: "ok",
            result: _context7.t0
          });
        case 16:
          _context7.prev = 16;
          _context7.t1 = _context7["catch"](9);
          console.error(_context7.t1);
          return _context7.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no hemos podido obtener la última valoración de este Jober."
          });
        case 20:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[9, 16]]);
  }));
  return _getLastReview.apply(this, arguments);
}
export function getAllReviews(_x23) {
  return _getAllReviews.apply(this, arguments);
}
/**
 * Asign a Jober to a Job
 * @method asignToJob
 * @name Jobin.Jober.asignToJob
 * @param {ParseObject} jober
 * @param {ParseObject} job
 * @returns {boolean} Success
 */
function _getAllReviews() {
  _getAllReviews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(jober) {
    var currentUser, isJober, Review, query;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context8.sent;
          if (currentUser) {
            isJober = currentUser.get("Jober");
            if (isJober) {
              jober = currentUser;
            }
          }
          Review = Parse.Object.extend("Review");
          query = new Parse.Query(Review);
          query.equalTo("Jober", jober);
          query.include(["Job.Title", "User.Name"]);
          query.descending("createdAt");
          _context8.prev = 9;
          _context8.next = 12;
          return query.find();
        case 12:
          _context8.t0 = _context8.sent;
          return _context8.abrupt("return", {
            status: "ok",
            result: _context8.t0
          });
        case 16:
          _context8.prev = 16;
          _context8.t1 = _context8["catch"](9);
          console.error(_context8.t1);
          return _context8.abrupt("return", {
            status: "error",
            result: "Hubo un error y no hemos podido descargar las valoraciones. Inténtalo de nuevo."
          });
        case 20:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[9, 16]]);
  }));
  return _getAllReviews.apply(this, arguments);
}
export function asignToJob(_x24, _x25) {
  return _asignToJob.apply(this, arguments);
}
function _asignToJob() {
  _asignToJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(jober, job) {
    var jobType, result, _result;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          jobType = job.get("JobType");
          if (!(jobType === "fixed" || jobType === "transport")) {
            _context9.next = 19;
            break;
          }
          _context9.prev = 2;
          _context9.next = 5;
          return Parse.Cloud.run("changeFixedAppointment", {
            jobId: job.id,
            joberId: jober.id,
            sessionToken: sessionToken.getToken()
          });
        case 5:
          result = _context9.sent;
          if (!result) {
            _context9.next = 10;
            break;
          }
          return _context9.abrupt("return", {
            status: "ok",
            result: true
          });
        case 10:
          return _context9.abrupt("return", {
            status: "error",
            result: "Hubo un error al intentar asignar el Jober al trabajo"
          });
        case 11:
          _context9.next = 17;
          break;
        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9["catch"](2);
          console.error(_context9.t0);
          return _context9.abrupt("return", {
            status: "error",
            result: "Hubo un error al intentar asignar el Jober al trabajo"
          });
        case 17:
          _context9.next = 34;
          break;
        case 19:
          _context9.prev = 19;
          _context9.next = 22;
          return Parse.Cloud.run("buyJobForJober", {
            jobId: job.id,
            joberId: jober.id,
            sessionToken: sessionToken.getToken()
          });
        case 22:
          _result = _context9.sent;
          if (!_result) {
            _context9.next = 27;
            break;
          }
          return _context9.abrupt("return", {
            status: "ok",
            result: true
          });
        case 27:
          return _context9.abrupt("return", {
            status: "error",
            result: "Hubo un error al intentar asignar el Jober al trabajo"
          });
        case 28:
          _context9.next = 34;
          break;
        case 30:
          _context9.prev = 30;
          _context9.t1 = _context9["catch"](19);
          console.error(_context9.t1);
          return _context9.abrupt("return", {
            status: "error",
            result: "Hubo un error al intentar asignar el Jober al trabajo"
          });
        case 34:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[2, 13], [19, 30]]);
  }));
  return _asignToJob.apply(this, arguments);
}